function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#FFF",
  strokeWidth: 3,
  fill: "#DFDFDF",
  width: 106,
  height: 106,
  rx: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.53 80.368c-1.057-3.16-2.971-6.346-5.795-8.2-5.432-3.596-11.762-5.514-17.883-7.567-1.476-.516-2.977-1.078-4.326-1.878-1.204-.714-1.657-2.177-1.937-3.463-.123-.68-.199-1.377-.238-2.064 4.438-6.053 7.382-15.932 7.382-24.032 0-12.641-7.164-16.164-16-16.164-8.838 0-16 3.518-16 16.159 0 8.39 3.156 18.682 7.861 24.66-.043.473-.099.945-.184 1.414-.28 1.286-.732 2.722-1.936 3.435-1.35.8-2.85 1.308-4.328 1.824-6.12 2.053-12.45 3.864-17.881 7.46-2.825 1.854-4.739 5.257-5.794 8.416-1.087 3.28-1.531 7.34-1.464 10.632H92.993c.068-3.29-.378-7.352-1.464-10.632z",
  fill: "#020201",
  fillRule: "nonzero"
}));

function SvgAvatarPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 104,
    viewBox: "0 0 106 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.969b294a.svg";
export { ForwardRef as ReactComponent };